module.exports = __webpack_public_path__ + "img/wallet-recharge.1c8c136a.png";